import { z } from 'zod';
/** 라이선스 종류. perpetual = 영구, subscription = 만료 있음. */
export const LicenseTypeSchema = z.enum(['perpetual', 'subscription']);
/** 발급 시 admin 이 입력하는 요청. */
export const IssueLicenseRequestSchema = z.object({
    customerId: z.string().uuid(),
    type: LicenseTypeSchema,
    /** 구독일 때만 필요. ISO 8601 timestamp. */
    expiresAt: z.string().datetime().nullable().optional(),
    /** 활성화 허용 횟수 (rehost 정책). 기본 1. */
    maxActivations: z.number().int().min(1).max(10).default(1),
    /** 최대 동시 사용자 수. null/미지정 = 무제한 (기존 라이선스 호환). */
    maxUsers: z.number().int().positive().nullable().optional(),
    /**
     * 등급. 지정하면 features 는 `featuresOfLevel()` 로 **파생**하고 요청의 features 는 무시한다.
     * null = 수동 features 경로(레거시·특수 발급).
     */
    level: z.string().nullable().optional(),
    /** features allowlist. ['*'] = 전체. level 이 있으면 무시된다. */
    features: z.array(z.string()).min(1).default(['base']),
    /** 본사 admin 노트 (계약/PO 번호 등). */
    notes: z.string().max(2000).optional(),
});
/** 발급된 라이선스의 공개 표현 (admin UI 에 보임). */
export const LicenseSchema = z.object({
    id: z.string().uuid(),
    customerId: z.string().uuid(),
    licenseKey: z.string(),
    type: LicenseTypeSchema,
    expiresAt: z.string().datetime().nullable(),
    maxActivations: z.number().int(),
    /** 최대 동시 사용자 수. null = 무제한. */
    maxUsers: z.number().int().nullable(),
    /** 등급 키. null = 사용자 지정(수동 features). */
    level: z.string().nullable(),
    activationCount: z.number().int(),
    features: z.array(z.string()),
    revokedAt: z.string().datetime().nullable(),
    notes: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=license.js.map